export enum VendorServiceTypes {
  Domestic = 'domestic',
  International = 'international',
  Both = 'both', // Remove ??
}
